module.exports = __webpack_public_path__ + "static/media/vimeo.65db698d.svg";